import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldMessage']),
        getByChannel: state => idChannel => {
            return state.objs.filter(msg => msg.channel === idChannel);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldMessage'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldMessage'])
    },
}